import React from "react";
import styles from "./DownloadModal.module.scss";
import ModalBackground from "assets/img-winaz/download-popup/bgpopup.webp";
import CloseButtonImage from "assets/img-winaz/button/btnclose.webp";
import QRCode from "react-qr-code";
import { useMyStore } from "store";
import { getAppDownloadPath } from "utils/download";

type DownloadModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

const DownloadModal: React.FunctionComponent<DownloadModalProps> = ({
  isOpen,
  onClose,
}) => {
  const bootstrap = useMyStore((s) => s.bootstrap);
  const handleOverlayClick = React.useCallback(
    (event: React.MouseEvent<HTMLDivElement>) => {
      if (event.target === event.currentTarget) {
        onClose();
      }
    },
    [onClose],
  );

  React.useEffect(() => {
    if (!isOpen) {
      return undefined;
    }

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", handleKeyDown);

    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [isOpen, onClose]);

  if (!isOpen) {
    return null;
  }

  const { androidUrl, iosUrl, resourceDomain } = getAppDownloadPath(bootstrap);
  const downloadUrl = `https://${resourceDomain || ""}/widgets/download-app/?androidUrl=${encodeURIComponent(androidUrl || "")}&iosUrl=${encodeURIComponent(iosUrl || "")}`;

  return (
    <div className={styles.overlay} onClick={handleOverlayClick}>
      <div className={styles.modalWrapper}>
        <div
          className={styles.modal}
          role="dialog"
          aria-modal="true"
          aria-label="Tải WinAZ cho di động"
          style={{ backgroundImage: `url(${ModalBackground})` }}
        >
          <button
            type="button"
            className={styles.closeButton}
            onClick={onClose}
            aria-label="Đóng"
          >
            <img src={CloseButtonImage} alt="" aria-hidden="true" />
          </button>

          <div className={styles.contentLayer}>
            <p className={styles.heading}>Quét QR để nhận link tải game</p>
            <a
              className={styles.qrWrapper}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Mở trang tải WinAZ"
            >
              <QRCode
                value={downloadUrl}
                style={{ height: "100%", width: "100%" }}
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DownloadModal;
